import {
    createFromIconfontCN
} from "@ant-design/icons";
// import icons from './icons/iconfont.js'

const IconFont = createFromIconfontCN({
    // scriptUrl: "//at.alicdn.com/t/font_2312727_heiyab8djzw.js", //icons,
    // scriptUrl: icons
    scriptUrl: '//img0.didiglobal.com/static/csglobal/iconfont.js'
});

export default IconFont